import React, {Component} from 'react';
import {reqGetPerformanceReport} from '../../api';
import {Card, Table, Tabs} from 'antd';

const {TabPane} = Tabs;

export default class PerformanceReport extends Component {

  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      data: []
    };

    //initialize table columns
    this.initColumns();
  }

  componentDidMount() {
    this.ajaxGetPerformanceReport('weekly');
  }

  onChange = (type) => {
    this.ajaxGetPerformanceReport(type);
  }

  ajaxGetPerformanceReport = (type) => {
    this.setState({loading: true});
    reqGetPerformanceReport(type)
      .then(response => {
        const collection = response.data.collection;
        const total_sold = response.data.total_sold;
        const sorted = this.sortData(collection, total_sold);
        this.setState({loading: false, data: sorted});

      })
      .catch(error => {
        console.log(error.response);
      });
  }

  sortData = (collection, total_sold) => {
    //---- combine collection and total_sold to one array ----
    // Default fields for zero values
    const defaultStats = {
      ring_registry_sold: 0,
      resin_registry_sold: 0,
      engagement_rings_sold: 0,
      wedding_bands_sold: 0,
      jewellery_sold: 0,
      total_items_sold: 0,
      retail_engagement_rings: 0.0000,
      retail_wedding_bands: 0.0000,
      retail_jewellery: 0.0000,
      total_retail_amount: 0.0000,
      total_amount: 0.0000
    };
    // Step 1: create a lookup map for each array
    const map1 = new Map(collection.map(item => [`${item.date_start}-${item.sales_representitive}`, item]));
    const map2 = new Map(total_sold.map(item => [`${item.date_start}-${item.sales_representitive}`, item]));
    // Step 2: merge keys from both arrays
    const allKeys = new Set([...map1.keys(), ...map2.keys()]);
    // Step 3: build array3
    const array3 = Array.from(allKeys).map(key => {
      const item1 = map1.get(key) || {};
      const item2 = map2.get(key) || {};

      const date_start = item1.date_start || item2.date_start;
      const sales_representitive = item1.sales_representitive || item2.sales_representitive;
      const salesperson = item1.salesperson || item2.salesperson;

      return {
        id: `${date_start}-${sales_representitive}`,
        sales_representitive,
        salesperson,
        date_start,
        date_end: item1.date_end || item2.date_end,
        total_amount: item1.total_amount || 0.0000,
        ring_registry_sold: item2.ring_registry_sold || 0,
        resin_registry_sold: item2.resin_registry_sold || 0,
        engagement_rings_sold: item2.engagement_rings_sold || 0,
        wedding_bands_sold: item2.wedding_bands_sold || 0,
        jewellery_sold: item2.jewellery_sold || 0,
        total_items_sold: item2.total_items_sold || 0,
        retail_engagement_rings: item2.retail_engagement_rings || 0.00000,
        retail_wedding_bands: item2.retail_wedding_bands || 0.0000,
        retail_jewellery: item2.retail_jewellery || 0.0000,
        total_retail_amount: item2.total_retail_amount || 0.0000
      };
    });

    //---- add total to array ----
    //Step 1: group by date_start
    const grouped = array3.reduce((acc, item) => {
      if (!acc[item.date_start]) acc[item.date_start] = [];
      acc[item.date_start].push(item);
      return acc;
    }, {});
    //Step 2: calculate totals per date_start
    const totals = Object.entries(grouped).map(([date_start, items]) => {
      const first = items[0]; // for date_end or other static info
      const total = items.reduce(
        (sum, cur) => ({
          total_amount: sum.total_amount + parseFloat(cur.total_amount || 0),
          ring_registry_sold: sum.ring_registry_sold + parseFloat(cur.ring_registry_sold || 0),
          resin_registry_sold: sum.resin_registry_sold + parseFloat(cur.resin_registry_sold || 0),
          engagement_rings_sold: sum.engagement_rings_sold + parseFloat(cur.engagement_rings_sold || 0),
          wedding_bands_sold: sum.wedding_bands_sold + parseFloat(cur.wedding_bands_sold || 0),
          jewellery_sold: sum.jewellery_sold + parseFloat(cur.jewellery_sold || 0),
          total_items_sold: sum.total_items_sold + parseFloat(cur.total_items_sold || 0),
          retail_engagement_rings: sum.retail_engagement_rings + parseFloat(cur.retail_engagement_rings || 0),
          retail_wedding_bands: sum.retail_wedding_bands + parseFloat(cur.retail_wedding_bands || 0),
          retail_jewellery: sum.retail_jewellery + parseFloat(cur.retail_jewellery || 0),
          total_retail_amount: sum.total_retail_amount + parseFloat(cur.total_retail_amount || 0),
        }),
        {
          total_amount: 0,
          ring_registry_sold: 0,
          resin_registry_sold: 0,
          engagement_rings_sold: 0,
          wedding_bands_sold: 0,
          jewellery_sold: 0,
          total_items_sold: 0,
          retail_engagement_rings: 0,
          retail_wedding_bands: 0,
          retail_jewellery: 0,
          total_retail_amount: 0,
        }
      );
      // create total object
      return {
        id: `${date_start}-0`,
        sales_representitive: 0,
        salesperson: "Total",
        date_start,
        date_end: first.date_end,
        total_amount: total.total_amount.toFixed(4),
        ring_registry_sold: total.ring_registry_sold,
        resin_registry_sold: total.resin_registry_sold,
        engagement_rings_sold: total.engagement_rings_sold,
        wedding_bands_sold: total.wedding_bands_sold,
        jewellery_sold: total.jewellery_sold,
        total_items_sold: total.total_items_sold,
        retail_engagement_rings: total.retail_engagement_rings.toFixed(4),
        retail_wedding_bands: total.retail_wedding_bands.toFixed(4),
        retail_jewellery: total.retail_jewellery.toFixed(4),
        total_retail_amount: total.total_retail_amount.toFixed(4),
      };
    });

    // Step 3: merge all data + totals
    const result = [...array3, ...totals];

    //---- sort by date start date ----
    const sortByIdDesc = (arr) =>
      [...arr].sort((a, b) => b.id.localeCompare(a.id, undefined, {numeric: true}));
    // usage
    const sorted = sortByIdDesc(result);

    return sorted;
  }

  //initial table columns
  initColumns = () => {
    this.columns = [
      {
        title: 'Date',
        dataIndex: 'date_start',
      },
      {
        title: 'Sales',
        dataIndex: 'salesperson',
      },
      {
        title: 'E/R',
        dataIndex: 'engagement_rings_sold',
      },
      {
        title: 'W/B',
        dataIndex: 'wedding_bands_sold',
      },
      {
        title: 'J/L',
        dataIndex: 'jewellery_sold',
      },
      {
        title: 'RI',
        dataIndex: 'ring_registry_sold',
      },
      {
        title: 'RE',
        dataIndex: 'resin_registry_sold',
      },
      {
        title: 'Total',
        dataIndex: 'total_items_sold',
      },
      {
        title: 'E/R Retail',
        dataIndex: 'retail_engagement_rings',
        render: (value) => {
          if (value == null) return '-';
          return `$${Number(value).toLocaleString()}`;
        },
      },
      {
        title: 'W/B Retail',
        dataIndex: 'retail_wedding_bands',
        render: (value) => {
          if (value == null) return '-';
          return `$${Number(value).toLocaleString()}`;
        },
      },
      {
        title: 'J/L Retail',
        dataIndex: 'retail_jewellery',
        render: (value) => {
          if (value == null) return '-';
          return `$${Number(value).toLocaleString()}`;
        },
      },
      {
        title: 'Total Retail',
        dataIndex: 'total_retail_amount',
        render: (value) => {
          if (value == null) return '-';
          return `$${Number(value).toLocaleString()}`;
        },
      },
      {
        title: 'Total Collection',
        dataIndex: 'total_amount',
        render: (value) => {
          if (value == null) return '-';
          return `$${Number(value).toLocaleString()}`;
        },
      },
    ]
  };


  render() {
    const {loading, data} = this.state;

    return (
      <Card>
        <Tabs defaultActiveKey="1" onChange={this.onChange}>
          <TabPane tab="Weekly" key="weekly">
          </TabPane>
          <TabPane tab="Monthly" key="monthly">
          </TabPane>
          <TabPane tab="Quarterly" key="quarterly">
          </TabPane>
        </Tabs>
        <Table
          loading={loading}
          rowKey="id"
          columns={this.columns}
          dataSource={data}
          size="small"
          pagination={false}
          onRow={(record) => ({
            style:
              record.sales_representitive === 0
                ? {
                  backgroundColor: '#fdf4f1', // light yellow highlight
                  fontWeight: 'bold',
                }
                : {},
          })}
        />
      </Card>

    )
  }

}